import { FC } from 'react';
import ExclusionsOptionsMenu from '../components/ExclusionsOptionsMenu';
import { Exclusion } from '../types/exclusion-types';

const ExclusionsOptionsContainer: FC<
  React.PropsWithChildren<ExclusionsOptionsContainerProps>
> = ({ exclusion }) => {
  return <ExclusionsOptionsMenu exclusion={exclusion} />;
};

export interface ExclusionsOptionsContainerProps {
  exclusion: Exclusion;
}

export default ExclusionsOptionsContainer;
